// Adds the ability to detect leaked Model instances and provides utility functions to help debug them.
//
// Usage:
// 1. Enable leak detection in console (automatically enabled in development mode)
//      Model.enableVueLeakDetection()
// 3. Use the following functions to debug:
//      Model.destroyedModelInfo() - Print info about destroyed Model instances
//      Model.destroyedModelsByName('ModelName') - Get destroyed Model instances by name
//      Model.containmentPaths(targetObject) - Get paths to the target object from Model instance

import Model from 'src/models/model'
import { containmentPaths } from 'src/utils/ContainmentPathFinder'
import WeakRefSet from 'src/utils/WeakRefSet'

let destroyedModels = new WeakRefSet()

function destroyedModelInfo () {
  const models = destroyedModels.items()

  const groupedModelNames = _(models)
    .map('typeName')
    .groupBy()
    .map((v, k) => [k, v.length])
    .sortBy(p => -p[1])
    .map(p => `${p[0]}->${p[1]}`)
    .value()
    .join('\n')

  console.log(`Destroyed model instances still in memory (${models.length}):\n${groupedModelNames}`)
}

function destroyedModelsByName (name) {
  const models = destroyedModels.items()
  return _.filter(models, model => model.typeName === name)
}

function containmentPathsHelper (targetObject, root, keysOnly = false, fullPath = false) {
  return containmentPaths(targetObject, root, keysOnly, fullPath)
}

let leakTimer
function monitorLeaks (interval = 2000) {
  if (leakTimer) {
    clearInterval(leakTimer)
  }

  leakTimer = setInterval(() => {
    destroyedModelInfo()
  }, interval)
}

function stopLeakMonitoring () {
  if (leakTimer) {
    clearInterval(leakTimer)
  }
}

let leakDetectionEnabled = false
Model.enableModelLeakDetection = function () {
  if (leakDetectionEnabled) {
    return
  }

  destroyedModels = new WeakRefSet()
  Model.trackDestroyed = function (model) {
    destroyedModels.add(model)
  }
  Model.destroyedModelInfo = destroyedModelInfo
  Model.destroyedModelsByName = destroyedModelsByName
  Model.containmentPaths = containmentPathsHelper
  Model.monitorLeaks = monitorLeaks
  Model.stopLeakMonitoring = stopLeakMonitoring

  leakDetectionEnabled = true
}

export default async ({ app }) => {
  // By default turn on leak detection in development mode
  if (process.env.NODE_ENV === 'development') {
    Model.enableModelLeakDetection()
  }
}
